import { isLoggedIn } from '@utils/helpers/auth';
import { Navigate, Outlet } from 'react-router-dom';

const Public = () => {
  return isLoggedIn() ? <Navigate to="/" /> : <Outlet />;
};

export default Public;
